export default {
  NeverLock: 0,
  LockOnRFQ: 1
}